<!-- Breadcrumbs -->
<!-- <div class="breadcrumbs"style= "font-family: 'Poppins'">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>Webinar</li>
                </ul>
            </div>
        </div>
    </div>
</div> -->

<section class="header">
    <div class="container_box">
        <div class="row_box">
            <div class="col">
                <!-- Start center Logo -->
                <!-- <div class="mu-logo-area">
                    <a class="mu-logo" href="#"> <img src="assets/images/logo.png" alt="logo" ></a> 
                </div> -->
                <!-- End center Logo -->

                <h2 class="main-heading text-left">
                    Securing Financial Mobile Apps with
                    Mobile RASP
                </h2>
                <div class="inner-row">
                    <div class="col">
                        <h3 class="date">
                            <i class='bx bx-calendar'></i><var>16<sup>th</sup> Oct 2023</var>
                        </h3>
                    </div>
                    <div class="col">
                        <h3 class="time">
                            <i class='bx bxs-hourglass-top'></i><var>4 PM to 5 PM</var>
                        </h3>
                    </div>
                </div>
                <p class="para-line white">
                    Runtime Application Self Protection for Mobile Apps (In-App Protection)</p>
            </div>
            <div class="col" #target>
                <div class="form-area" style="font-family: 'Poppins'">
                    <h2 class="form-heading" style="font-family: 'Poppins'">
                        Register Now
                    </h2>

                    <hr>
                    <form [formGroup]="demoForm" class="booking-form" id="form">
                        <!-- <div class="form-row"> -->
                        <div class="col">
                            <div class="input-field">
                                <label for="name" required>Name*</label>
                                <input formControlName="name" type="text" id="name" placeholder=""
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                                    <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                                    <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
                                </div>
                            </div>
                        </div>
                        <!-- </div> -->
                        <div class="input-field">
                            <label for="emailId">Work Email*</label>
                            <input type="email" id="emailId" placeholder="" required formControlName="email"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email
                                </div>
                            </div>
                        </div>
                        <div class="input-field">
                            <!-- pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}" -->
                            <label for="contactnumber">Phone Number*</label>
                            <input formControlName="contactnumber" type="tel" id="contactnumber" name="contactnumber"
                                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
                            <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                                <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                                </div>
                                <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                                    Mobile
                                    Number.
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="input-field">
                                <label for="Company">Company*</label>
                                <input type="text" id="company" formControlName="company_name"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
                                </div>
                            </div>

                            <div class="input-field">
                                <label for="Company">Designation*</label>
                                <input type="text" id="designation" formControlName="designation"
                                    [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
                                <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                                    <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="input-field">
                            <button class="btn" (click)="submitDemoForm()">
                                <!-- <a href="thankyou.html"> -->
                                Register Now
                                <!-- </a> -->
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Header section ends from here -->
<section class="topics" style="font-family: 'Poppins', sans-serif;">
    <div class="container_box">

        <h2 class="heading" style="font-family: 'Poppins'; color:#163e6f;">
            Meet Our Speakers
        </h2>
    </div>
    <div class="container p-5" style="max-width: inherit;">
        <div class="row justify-content-center align-items-center">
            <div class="col-md-3 text-center">
                <img class="card-img-top" style="text-align: center; width: 40%; border-radius: 50%;"
                    src="assets/images/new/shivkumar.webp" alt="Card image cap">
                <div class="row" style="display: contents;">
                    <h5 class="mt-3" style="font-size: 19px; font-weight: 600">Shivkumar Pandey</h5>
                    <h6 class="mt-2" style="font-size: 17px;">Group CISO <br> Bombay Stock Exchange</h6>
                </div>
            </div>
            <div class="col-md-3 text-center">
                <img class="card-img-top" style="text-align: center; width: 40%; border-radius: 50%;"
                    src="assets/images/new/rajesht.webp" alt="Card image cap">
                <div class="row" style="display: contents;">
                    <h5 class="mt-3" style="font-size: 19px; font-weight: 600">Rajesh Thapar</h5>
                    <h6 class="mt-2" style="font-size: 17px;">EVP & CISO<br>Axis Bank</h6>
                </div>
            </div>
            <div class="col-md-3 text-center">
                <img class="card-img-top" style="text-align: center; width: 40%; border-radius: 50%;"
                    src="assets/images/about/navneethan-m.webp" alt="Card image cap">
                <div class="row" style="display: contents;">
                    <h5 class="mt-3" style="font-size: 19px; font-weight: 600">Navaneethan M</h5>
                    <h6 class="mt-2" style="font-size: 17px;">Senior Cyber Security<br>Leader</h6>
                </div>
            </div>
            <div class="col-md-3 text-center">
                <img class="card-img-top" style="text-align: center; width: 40%; border-radius: 50%;"
                    src="assets/images/about/manish.webp" alt="Card image cap">
                <div class="row" style="display: contents;">
                    <h5 class="mt-3" style="font-size: 19px; font-weight: 600;">Manish Mimani</h5>
                    <h6 class="mt-2" style="font-size: 17px;">Founder CEO<br>Protectt.ai</h6>
                </div>
            </div>
        </div>
    </div>


</section>
<!-- Topic section starts from here -->
<section class="topics" style="font-family: 'Poppins', sans-serif;">
    <div class="container_box">

        <h2 class="heading" style="font-family: 'Poppins'; color:#163e6f;">
            About this webinar
        </h2>
        <p class="para-line" style="font-family: 'Poppins';text-align:center !important">
            Join us for an insightful webinar. Join us for an insightful webinar to help in bolstering the Mobile
            Application Security for Banks, Financial institutions and FinTech's. This session will focus on Latest
            Trends & Technologies for Mobile App Security.</p>

        <div class="topics-row">
            <div class="col topic-box">
                <i class='bx bx-mobile-alt'></i>
                <h2 class="topic-heading" style="font-family: 'Poppins'">
                    Mobile App Security
                </h2>
                <p class="para-line" style="font-family: 'Poppins'">
                    Financial Mobile App Security Threat Landscape Overview
                </p>
                <br>

                <br>
                <p style="font-size: 16px;">(15 minutes)</p>
            </div>
            <div class="col topic-box">
                <i class='bx bx-target-lock'></i>
                <h2 class="topic-heading" style="font-family: 'Poppins'">
                    Challenges
                </h2>
                <p class="para-line" style="font-family: 'Poppins'">
                    Key Security Challenges in Financial Mobile Apps
                </p>
                <br>

                <br>
                <p style="font-size: 16px;">(15 minutes)</p>
            </div>
            <div class="col topic-box">
                <i class='bx bx-mobile-vibration'></i>
                <h2 class="topic-heading" style="font-family: 'Poppins'">
                    RASP
                </h2>
                <p class="para-line" style="font-family: 'Poppins'">
                    Best Practices for Financial Mobile App Security with RASP
                </p>
                <br>

                <br>
                <p style="font-size: 16px;">(15 minutes)</p>

            </div>
            <div class="col topic-box">
                <i class='bx bx-mouse-alt'></i>
                <h2 class="topic-heading">
                    Demonstration
                </h2>
                <p class="para-line">
                    Use cases demonstration 
                </p>
                <br>

                <br>
                <p style="font-size: 16px;">(15 minutes)</p>
            </div>
        </div>
    </div>
</section>
<!-- Topic section ends from here -->


<!-- Host section ends -->

<!--Students Review-->
<div class="container_box" style="font-family: 'Poppins', sans-serif;">
    <h1 style="display: block; font-size: 32px;color: black;font-family: 'Poppins'">Who Should Attend?</h1>
    <div class="list mt-5">
        <ul>
            <li>CISO</li>
            <li>CIO, CEO </li>
            <li>Android and iOS developers </li>
            <li>Mobile engineers </li>
            <li>DevOps engineers </li>
            <li>QA, test engineers, and SDETs </li>
            <li>Security engineers </li>
        </ul>

    </div>
</div>
<section class="footer">
    <div class="container_box ">
        <h2 class="heading white" style="font-family: 'Poppins', sans-serif;">Join the Webinar</h2>
        <div class="text-center" style="display: flex; justify-content: center; margin-top: 30px;">
            <button class="btn" (click)="scroll(target)">

                Register Now

            </button>
        </div>
    </div>
</section>